import ButtonBack from "../../../component/buttton/ButtonBack.component"
import Assesment from "../Assessment.component"
import ButtonLink from "../../../component/buttton/ButtonLink.component";
import { Grid } from "@material-ui/core";
import GridComponent from "../../../component/grid/GridComponent.component";
import { BiCalendarStar, BiChart, BiChevronRight } from "react-icons/bi";
import { FiPlusSquare } from "react-icons/fi";

export default function Details() {
    return (
        <>
            <ButtonBack to='/' />
            <GridComponent spacing={2}>
                <Grid item>
                    <ButtonLink title='Cadastrar itens de Avaliação' link={`/avaliacao-loja`} icon={<FiPlusSquare color='#FFF' size={25} />} />
                </Grid>
                <Grid item>
                    <ButtonLink title='Avaliações Funcionários' link={`/avaliacao-loja/avaliacoes`} icon={<BiCalendarStar color='#FFF' size={25} />} />
                    </Grid>
                
                <Grid item>
                    <ButtonLink title='Dashboard Avaliações' link={`/avaliacao-loja/dashboard`} icon={<BiChart color='#FFF' size={25} />} />
                </Grid>
            </GridComponent>
            
        </>
    )
}